import { render, staticRenderFns } from "./Locations.vue?vue&type=template&id=88af3c4a&scoped=true"
import script from "./Locations.vue?vue&type=script&lang=js"
export * from "./Locations.vue?vue&type=script&lang=js"
import style0 from "./Locations.vue?vue&type=style&index=0&id=88af3c4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88af3c4a",
  null
  
)

export default component.exports